export default __webpack_public_path__ + "images/netsuite-oracle.svg";